const TOPICS = [
  {
    tag: '独家爆料',
    title: '顶流男星深夜密会神秘女子，酒店共度8小时',
    summary: '据知情人士透露，某顶流男星近日被拍到深夜与一名神秘女子先后进入某五星级酒店，直至次日清晨才分别离开。该女子身份引发网友热议。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20scene%20of%20luxury%20hotel%20entrance%20at%20night%2C%20warm%20amber%20lighting%2C%20dramatic%20shadows%2C%20paparazzi%20style%20photography%20aesthetic%2C%20mysterious%20atmosphere%2C%20no%20people%20visible%2C%20abstract%20editorial%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    date: '2小时前',
    hot: true,
  },
  {
    tag: '综艺爆料',
    title: '年度最炸裂！热门综艺录制现场爆发激烈冲突',
    summary: '某热门综艺最新一期录制过程中，两位常驻嘉宾因游戏环节意见不合爆发激烈口角，现场一度陷入尴尬。节目组紧急暂停录制进行调解。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20set%20with%20warm%20stage%20lighting%2C%20empty%20stage%20with%20intense%20atmosphere%2C%20cinematic%20lighting%20contrast%2C%20entertainment%20show%20production%20aesthetic%2C%20dramatic%20shadows%2C%20no%20people&width=800&height=500&seq=carousel-02&orientation=landscape',
    date: '5小时前',
    hot: true,
  },
  {
    tag: '税务风波',
    title: '娱乐圈税务风暴持续，多名艺人被约谈补缴税款',
    summary: '税务部门近期加大了对娱乐行业的稽查力度，涉及多名一线艺人及网红主播。据悉部分艺人已主动配合补缴税款及滞纳金，金额高达数千万元。',
    image: 'https://readdy.ai/api/search-image?query=Serious%20dark%20office%20scene%20with%20official%20documents%20and%20envelopes%20on%20a%20desk%2C%20dramatic%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20warm%20dark%20tones%2C%20no%20people&width=800&height=500&seq=carousel-03&orientation=landscape',
    date: '8小时前',
    hot: false,
  },
  {
    tag: '新剧路透',
    title: '年度古装巨制开机，顶流阵容路透照首度曝光',
    summary: '备受期待的S+级古装剧今日在横店低调开机，男女主角均为一线顶流。现场路透照显示剧组服化道精良，场景搭建规模宏大，引发粉丝狂欢。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20film%20set%20with%20traditional%20architecture%20and%20elaborate%20costumes%20on%20display%2C%20cinematic%20warm%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20historical%20drama%20production%20aesthetic%2C%20no%20people%20faces%20visible&width=800&height=500&seq=carousel-04&orientation=landscape',
    date: '12小时前',
    hot: true,
  },
  {
    tag: '婚变传闻',
    title: '知名明星夫妻疑似婚变，社交平台互相取关引猜测',
    summary: '一对在圈内被称为模范夫妻的明星近日被网友发现已在社交平台互相取关，且已多月未有同框互动。双方工作室暂未回应此事，粉丝纷纷喊话求真相。',
    image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20with%20warm%20dramatic%20lighting%2C%20abstract%20emotional%20editorial%20photography%2C%20dark%20moody%20tones%20with%20coral%20accents%2C%20cinematic%20composition%2C%20no%20people&width=800&height=500&seq=carousel-05&orientation=landscape',
    date: '1天前',
    hot: false,
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            每日精选最热的明星大瓜与吃瓜现场专题，让你一次吃个够
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TOPICS.map((item, i) => (
            <article
              key={i}
              className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              } ${i === 1 ? 'lg:col-span-1' : ''}`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="px-2 py-1 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap flex items-center gap-1">
                      <i className="ri-fire-line text-[10px]"></i>热
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">
                  {item.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.date}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}